import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { API_URL } from '../Utils/api';

export const useConversationsList = (token) => {
  return useQuery({
    queryKey: ['conversations', 'list'],
    queryFn: async () => {
      if (!token) return [];
      const res = await axios.get(`${API_URL}/conversations_list`, {
        headers: { Authorization: `Bearer${token}` },
      });
      return res.data || [];
    },
    enabled: !!token,
    staleTime: 1000 * 30,
  });
};

export const useSingleChat = (token, receiverId) => {
  return useQuery({
    queryKey: ['conversations', 'chat', receiverId],
    queryFn: async () => {
      if (!token || !receiverId) return [];
      const res = await axios.get(`${API_URL}/conversations/${receiverId}`, {
        headers: { Authorization: `Bearer${token}` },
      });
      return res.data || [];
    },
    enabled: !!token && !!receiverId,
    staleTime: 1000 * 10,
  });
};
